import { camelCase, upperFirst } from "lodash";

export function componentName(string) {
  return upperFirst(camelCase(string));
}
